import React from 'react';
import Breadcrumb from '../components/breadcrumb/Breadcrumb';
import breadcrumbBg from '../assets/images/breadcrumb/1.jpg';
import HeaderBottomOne from '../common/header/HeaderBottomOne';
import HeaderTop from '../common/header/HeaderTop';
import Footer from '../common/footer/Footer';

import AboutExperience from '../components/home-about/AboutExperience';
import AboutTeam from '../components/home-about/AboutTeam';
import Cta from '../components/cta/Cta';


const About = () => {
    return (
        <>
            <HeaderTop />
            <HeaderBottomOne />
            <Breadcrumb 
                breadcrumbBg={breadcrumbBg}
                heading="Our Company"
                description="We are available for 24/7 for Cleaning & Gardening & Landscaping Services"
                currentPage="About Us"
            />
            <AboutExperience />
            <AboutTeam />
            <Cta />
            
            <Footer />
        </>
    )
}

export default About;

